import { foundationDialogStyles } from '@genesislcap/foundation-ui';
import { neutralForegroundRest, neutralLayer2 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { ColorHEX } from '../_common';
import { whiteWebRGBA } from '../_config/styles/colors';
import { defaultDialogActiveBGColor } from './styles/colors';
// See https://www.fast.design/docs/fast-element/leveraging-css/, https://www.fast.design/docs/design-systems/fast-frame
export const zeroDialogStyles = css `
  ${foundationDialogStyles}
  :host {
    --dialog-background: ${neutralLayer2};
  }

  dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    color: rgb(255 255 255 / 30%);
    border-radius: calc(var(--control-corner-radius) * 1px);
    border: 1px solid ${ColorHEX.lightGrey};
    text-align: left;
    line-height: normal;
    box-shadow: 0 2px 15px 0 rgb(0 0 0 / 35%);
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${ColorHEX.almostWhite};
    margin-bottom: calc(var(--design-unit) * 2px);
  }

  .bottom {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    color: ${ColorHEX.almostWhite};
  }

  :host slot:first-of-type {
    color: ${neutralForegroundRest};
  }

  ::slotted(zero-button) {
    margin-top: calc(var(--design-unit) * 4px - 1px);
  }

  .content-wrapper {
    min-width: var(--dialog-min-width);
    min-height: var(--dialog-min-height);
    height: fit-content;
    width: fit-content;
    max-width: var(--dialog-max-width);
    max-height: var(--dialog-max-height);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
  }

  .close-icon:hover svg {
    background-color: ${whiteWebRGBA(0.05)};
  }

  .close-icon:hover svg g path {
    fill: ${whiteWebRGBA(1)};
  }

  .close-icon:active svg {
    background-color: ${defaultDialogActiveBGColor};
  }

  .close-icon:active svg g path {
    fill: ${whiteWebRGBA(0.33)};
  }
`;
